export default "__VITE_ASSET__DH0NovwM__"